import React, { createContext, ReactNode, useContext } from 'react';
import { WHITE } from '~/Constants/Colors.constants';
import { PrivateLayoutType, usePrivateLayout } from './usePrivateLayout';
import { PrivateLayoutDetails } from './PrivateLayoutDetails';
import { IPrivateLayoutTitleWithAction } from './PrivateLayoutTitle';

const PrivateLayoutContext = createContext<PrivateLayoutType>({} as any);

export interface PrivateLayoutOptions {
  label: string;
  onClick: () => void;
}

export interface PrivateLayoutProps {
  children: ReactNode;
  backgroundColor?: string;
  title?: string | IPrivateLayoutTitleWithAction;
  actionName?: string;
  onActionTaken?: () => void;
  actionDisabled?: boolean;
  hideBackButton?: boolean;
  backRoute?: string;
  cancelInsteadOfBack?: boolean;
  options?: PrivateLayoutOptions[];
  isNew?: boolean;
  articleLink?: string;
  secondaryTitleActionElement?: JSX.Element | null;
  disableMobile?: boolean;
}

export const PrivateLayout = (props: PrivateLayoutProps) => {
  const contextStore = usePrivateLayout();
  const {
    children,
    backgroundColor = WHITE,
    title,
    actionName,
    onActionTaken,
    actionDisabled,
    hideBackButton,
    backRoute,
    cancelInsteadOfBack,
    options,
    isNew,
    articleLink,
    secondaryTitleActionElement,
    disableMobile = false,
  } = props;
  return (
    <PrivateLayoutContext.Provider value={contextStore}>
      <PrivateLayoutDetails
        backgroundColor={backgroundColor}
        title={title}
        actionName={actionName}
        onActionTaken={onActionTaken}
        actionDisabled={actionDisabled}
        hideBackButton={hideBackButton}
        backRoute={backRoute}
        cancelInsteadOfBack={cancelInsteadOfBack}
        options={options}
        isNew={isNew}
        articleLink={articleLink}
        secondaryTitleActionElement={secondaryTitleActionElement}
        disableMobile={disableMobile}
      >
        {children}
      </PrivateLayoutDetails>
    </PrivateLayoutContext.Provider>
  );
};

export const usePrivateLayoutContext = () => {
  const context = useContext(PrivateLayoutContext);
  if (!context || Object.keys(context).length === 0) {
    throw new Error('PrivateLayout could not be found');
  }
  return context;
};
